import { useState } from "react";
import cloneDeep from "lodash/cloneDeep";
import { AUS_PRODUCTS, US_PRODUCTS } from "../constants/pricing";

const usePricing = () => {
  const [country, setCountry] = useState("us");

  // NOTE: we clone deep because the `per_license` field will be overwritten during the operation
  const [products, setProducts] = useState({
    us: cloneDeep(US_PRODUCTS),
    aus: cloneDeep(AUS_PRODUCTS),
  });

  const updateData = (id, type, value) => {
    const index = products[country].findIndex((p) => p.id === id);
    if (index === -1) {
      return;
    }

    setProducts((products) => {
      const countryProducts = [...products[country]];
      countryProducts[index][type] = value;

      return {
        ...products,
        [country]: countryProducts,
      };
    });
  };

  const getOriginalPricing = (id, type) => {
    const products = country === "us" ? US_PRODUCTS : AUS_PRODUCTS;
    const index = products.findIndex((p) => p.id === id);
    return products[index][type];
  };

  const resetAllProducts = () => {
    const allProducts = {
      us: cloneDeep(US_PRODUCTS),
      aus: cloneDeep(AUS_PRODUCTS),
    };
    setProducts(allProducts);
    return allProducts;
  };

  return {
    country,
    products: products[country],
    setCountry,
    updateData,
    getOriginalPricing,
    resetAllProducts,
  };
};

export default usePricing;
